
import React, { Suspense } from "react";
import { Provider } from "react-redux";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { PersistGate } from "redux-persist/lib/integration/react";
import Loading from "./components/common/layout/Loading";
import Page404 from "./pages/common/Page404";
import { guestRoutes } from "./routes/guestRoutes";
import { protectedRoutes } from "./routes/protectedRoutes";
import store, { persistor } from "./store";

import ProtectedRoute from "./components/routes/ProtectedRoute";

const App = () => {
  return (
    <Provider store={store}>
      <PersistGate loading={<Loading />} persistor={persistor}>
        <BrowserRouter
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
          }}
        >
          <Suspense fallback={<Loading />}>
            <Routes>
              {guestRoutes.map((route, idx) => (
                <Route key={idx} path={route.path} element={route.element} />
              ))}
              {protectedRoutes.map((route, idx) => (
                <Route key={idx} path={route.path} element={<ProtectedRoute element={route.element} userTypes={route.userTypes} withLayout={route.withLayout} />} />
              ))}
              <Route path="*" element={<Page404 />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  );
};

export default App;
